export default "__VITE_ASSET__CaUFFxUP__"